import React, { useState, useMemo, useEffect } from 'react';

import { Card, CardBody, Table, HeaderTitle, MenuSVG } from '../../../../components';
// import { usersService, eventsService } from '../../../../services';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import page from '../../../../constants/pages/page';
import FraudPreventionColumns from './FraudPreventionColumns';
import { useFraudPreventionUIContext } from '../context/FraudPreventionUIContext';
import { useTranslation } from 'react-i18next';
import { fraudPreventionService } from '../../../../services';
import CustomAlert from '../../../../components/Alert';

export default function FraudPreventionTable () {
    const { t } = useTranslation();

    // sortKeyMap
    const customSortedKeyMap = { created_at_time: 'created_at' };
    const { sortedKeyMap, defaultSorted } = UIHelpers(customSortedKeyMap);
    // States
    const [totalRules, setTotalRules] = useState(0);

    // Context state
    const fraudPreventionUIContext = useFraudPreventionUIContext();
    const fraudPreventionUIProps = useMemo(() => {
        return {
            isLoading: fraudPreventionUIContext.isLoading,
            setIsLoading: fraudPreventionUIContext.setIsLoading,
            queryParams: fraudPreventionUIContext.queryParams,
            setQueryParams: fraudPreventionUIContext.setQueryParams,
            rules: fraudPreventionUIContext.rulesList,
            setRules: fraudPreventionUIContext.setRulesList,

        };
    }, [fraudPreventionUIContext]);

    const [alert, setAlert] = useState({
        severity: '',
        title: '',
        description: '',
        className: '',
    });
    const [openAlert, setOpenAlert] = useState(false);

    // List state

    // Functions

    const fetchRules = async () => {
        fraudPreventionUIProps.setIsLoading(true);
        const { sortField, sortOrder } = fraudPreventionUIProps.queryParams;
        const options = {
            filters: 'id_rule_type eq 1',
            order: `${sortedKeyMap[sortField] || sortField}-${sortOrder.toUpperCase()}`,
            pageSize: fraudPreventionUIProps.queryParams.pageSize,
            page: fraudPreventionUIProps.queryParams.pageNumber,
            with: 'actions',
            paginationActive: true
        };

        try {
            const response = await fraudPreventionService.getRules(options);
            const rules = Array.isArray(response?.result)
                ? response.result
                : (Array.isArray(response) ? response : []);
            const total = response?.metadata?.total ?? rules.length;

            setTotalRules(total);
            fraudPreventionUIProps.setRules(rules);
        }
        catch (error) {
            fraudPreventionUIProps.setRules([]);
            setTotalRules(0);
            setAlert((prevAlert) => ({
                ...prevAlert,
                severity: 'error',
                title: t('errors.generalTitle'),
                description: t('errors.generalDescription'),
                className: 'clientsMC_Alert--error',
            }));
            setOpenAlert(true);
        }
        finally { fraudPreventionUIProps.setIsLoading(false); }
    };

    const getData = async () => {
        fetchRules();
    };

    // Events

    // Handle query params changes. On any param change, fetch users.
    useEffect(
        () =>
            fraudPreventionUIProps.setQueryParams((prev) => ({
                ...prev,
                pageSize: localStorage.getItem('sizePerPage') || page.pageSize,
            }))
        ,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    useEffect(() => {
        // if (JSON.stringify(fraudPreventionUIProps.queryParams.url) !== undefined) {
        getData();
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fraudPreventionUIProps.queryParams]);

    // Main Component

    return (
        <>
            <CustomAlert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alert={alert}
                setAlert={setAlert}
            />

            <Card>
                <div>
                    <HeaderTitle
                        title={t('management.fraudPrevention.subTitle')}
                        icon={(<MenuSVG className='mr-1 mb-2'/>)}
                    />
                </div>
                <CardBody>
                    <Table
                        data={fraudPreventionUIProps.rules}
                        columns={FraudPreventionColumns()}
                        sort={defaultSorted}
                        total={totalRules}
                        onChange={fraudPreventionUIProps.setQueryParams}
                        isLoading={fraudPreventionUIProps.isLoading}
                        pagination={{
                            sizePerPage: fraudPreventionUIProps.queryParams.pageSize,
                            page: fraudPreventionUIProps.queryParams.pageNumber
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}
